import { useState } from "react";
import type { SmartViewArtifact } from "../../../../api/types/smartViewArtifactsTypes";
import type { ReportAuthorizationInfo } from "../../../../api/types/svTypes";
import ShareButton from "../sv/components/builder/common/sharing/ShareButton";
import ArtifactShareDialog from "./ArtifactShareDialog";

interface Props {
  artifact: SmartViewArtifact;
  name: string;
  onSharingUpdated: (authorization: ReportAuthorizationInfo, inheritFromParent: boolean) => void;
}

const ArtifactShareButton = ({ artifact, name, onSharingUpdated }: Props) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <>
      <ShareButton isPrivate={artifact.authorization.private} onClick={() => setIsDialogOpen(true)} />
      {isDialogOpen && (
        <ArtifactShareDialog
          artifact={artifact}
          name={name}
          onClose={() => setIsDialogOpen(false)}
          onSharingUpdated={onSharingUpdated}
        />
      )}
    </>
  );
};

export default ArtifactShareButton;
